import { createFeature, createReducer, on } from '@ngrx/store';
import { UserSettingsActions } from '../actions/user-settings.actions';
import { UserNotificationPreferenceModel } from '../../models/user-notification-preference.model';

export const userSettingsFeatureKey = 'userSettings';

export interface UserSettingsState {
  userPreferences: UserNotificationPreferenceModel;
}

export const initialState: UserSettingsState = {
  userPreferences: null
};

function clonePreferences(prefs: UserNotificationPreferenceModel): UserNotificationPreferenceModel {
  if (!prefs) {
    return null;
  }

  return {
    ...prefs,
    channelSetting: { ...prefs.channelSetting },
    taskSettings: prefs.taskSettings
      ? prefs.taskSettings.map(t => ({ ...t }))
      : [],
    accountSettings: prefs.accountSettings
      ? prefs.accountSettings.map(a => ({ ...a }))
      : [],
    projectTaskSettings: prefs.projectTaskSettings
      ? prefs.projectTaskSettings.map(t => ({ ...t }))
      : [],
  };
}

export const reducer = createReducer(
  initialState,

  on(
    UserSettingsActions.loadUserNotificationPreferencesSuccess,
    (state, action): UserSettingsState => ({
      ...state,
      userPreferences: clonePreferences(action.data),
    })
  ),

  on(
    UserSettingsActions.updateUserNotificationPreferences,
    (state, action): UserSettingsState => ({
      ...state,
      userPreferences: clonePreferences(action.data) ?? state.userPreferences,
    })
  ),
);

export const userSettingsFeature = createFeature({
  name: userSettingsFeatureKey,
  reducer,
});